import { PartialSite } from "../models/site";
import axiosConfig from "./axiosConfig";

const postSiteReportPreview = async (
  authToken: string,
  payload: PartialSite,
  siteName: string,
  reportName: string,
  options?: Record<string, any>,
  fileName?: string
): Promise<void> => {
  const response = await axiosConfig.post(
    `/site/preview/report?reportName=${reportName}${options ? `&options=${JSON.stringify(options)}` : ""}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      responseType: "blob",
    }
  );
  // Create a URL for the blob
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;

  // Set the download attribute with a default file name
  const currentDateTime = new Date()
    .toISOString()
    .replace(/:/g, "-")
    .replace(/\..+/, "");

  // Sanitize site name - lowercase, replace all space with dash, remove special characters, replace repeated dashes with a single dash
  const sanitizedSiteName = siteName
    .toLowerCase()
    .trim()
    .replace(/ /g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .replace(/-+/g, "-");

  // Build options string from all keys in options, with the keys sorted by name
  // in the format value1-value2
  const optionsString = Object.keys(options || {})
    .sort()
    .map((key) =>
      typeof options?.[key] === "boolean"
        ? `${key}-${options?.[key]}`
        : `${options?.[key]}`
    )
    .join("-");

  const contentType = response.headers["content-type"];
  const extension =
    typeof contentType === "string" &&
    contentType.indexOf("officedocument.spreadsheetml.sheet") > -1
      ? "xlsx"
      : "docx";

  link.setAttribute(
    "download",
    `${sanitizedSiteName}-${fileName}${optionsString ? `-${optionsString}` : ""}-${currentDateTime}.${extension}`
  );

  // Append the link to the body
  document.body.appendChild(link);

  // Programmatically click the link to trigger the download
  link.click();

  // Clean up and remove the link
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  }
  window.URL.revokeObjectURL(url);
};

export default postSiteReportPreview;
